<template>
    <div class="container-fluid pt-2">
        <div class="card">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <h5>Sales Order List</h5>
                    <div v-if="role != 'WAREHOUSE'">
                        <button type="button" class="btn btn-sm btn-success" @click="printRekapWa" :disabled="loading">
                            <i class="fab fa-whatsapp"></i> Whatsapp
                        </button>&nbsp;
                        <button type="button" class="btn btn-sm btn-warning" @click="processDownload"
                            :disabled="loading"><i class="fa fa-export"></i>Download</button>&nbsp;
                    </div>
                    <button type="button" class="btn btn-sm btn-info" @click="processDownloadJnt" :disabled="loading"><i
                            class="fa fa-export"></i>JNT</button>
                </div>
            </div>
            <div class="card-body" id="body-salesorder">
                <div class="row">
                    <div class="col-md-3 mb-3">
                        <select v-model="params.divisi_id" class="form-select">
                            <option value="" disabled>Select Divisi</option>
                            <option v-for="option in divisiOptions" :key="option.ID" :value="option.ID">
                                {{ (option as any).name }}
                            </option>
                        </select>
                    </div>

                    <div class="col-md-4 mb-3">
                        <select v-model="params.divisi_team_id" class="form-select">
                            <option value="">Select Team</option>
                            <option v-for="option in divisiTeamOptions" :key="option.ID" :value="option.ID">
                                {{ option?.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-2 mb-3">
                        <select v-model="params.shipping_id" class="form-select">
                            <option value="">Select Shipping</option>
                            <option v-for="option in shippingOptions" :key="option.ID" :value="option.ID">
                                {{ option?.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-3 mb-3">
                        <select v-model="params.courier_id" class="form-select">
                            <option value="">Select Courier</option>
                            <option v-for="option in courierOptions" :key="option.ID" :value="option.ID">
                                {{ option?.name }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-10 mb-3">
                        <multiselect v-model="params.status" tag-placeholder="Select Status" placeholder="Select Status"
                            label="name" track-by="code" :multiple="true" :taggable="true" :options="[
                                { code: 'PENDING', name: 'Pending' },
                                { code: 'APPROVED', name: 'Approved' },
                                { code: 'REJECTED', name: 'Rejected' },
                                { code: 'CANCELLED', name: 'Cancelled' },
                                { code: 'DELIVERY', name: 'Delivery' },
                                { code: 'RETURN', name: 'Return' },
                            ]">
                        </multiselect>
                    </div>
                    <div class="col-md-2 mb-3">
                        <select v-model="params.closed" class="form-select">
                            <option value="">Select Status</option>
                            <option value="CLOSED">Closed</option>
                            <option value="OPEN">Open</option>
                        </select>
                    </div>
                </div>
                <DataTable :headers="headers" :items="salesOrders" :loading="loading" :selectable="true" :total="total"
                    :params="params" @update:params="updateParams">
                    <template #item.transaction_date="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                        formatDateTime(item.transaction_date) }}</template>
                    <template #item.divisi_team_name="{ item }" style="white-space: nowrap;word-wrap: break-word;">
                        <span v-if="item.closed_date" style="color: green;">
                            {{ item.divisi_team_name }}
                        </span>
                        <span v-else>
                            {{ item.divisi_team_name }}
                        </span>
                    </template>
                    <template #item.customer="{ item }" style="white-space: nowrap;word-wrap: break-word;">{{
                        item.customer.name }}</template>
                    <template #item.bank_name="{ item }" style="white-space: nowrap;word-wrap: break-word;">
                        {{ item.bank_name }} - {{ item.bank_account_name }} ({{ item.bank_account_number }})</template>
                    <template v-if="role != 'WAREHOUSE'" #item.grand_total="{ item }"
                        style="white-space: nowrap;word-wrap: break-word;">{{
                            formatCurrency(item.grand_total) }}</template>
                    <template v-if="role == 'WAREHOUSE'" #item.order_details="{ item }"
                        style="white-space: nowrap;word-wrap: break-word;">{{
                            itemDetail(item.order_details) }}</template>
                    <template #item.order_details="{ item }" style="white-space: nowrap;word-wrap: break-word;">
                        <template v-for="detail in item.order_details" :key="detail.ID">
                            {{ detail.name }} ({{ detail.quantity }}) <br>
                        </template>
                    </template>
                    <template #item.customer_data="{ item }" style="white-space: nowrap;word-wrap: break-word;">
                        {{ item.customer_name }} - {{ item.customer_phone }} - {{ item.customer_address }}
                    </template>
                    <template #item.description="{ item }" style="white-space: nowrap;word-wrap: break-word;">
                        <span v-if="item.closed_date" style="color: green;">
                            <b>Closed - {{ item.interaction_name }} - {{ item.description }}</b>
                        </span>
                        <span v-else>
                            <b>Open - {{ item.interaction_name }} - {{ item.description }}</b>
                        </span></template>
                    <template #item.actions="{ item }">
                        <button class="btn btn-sm btn-info" @click="checkRelated(item as any)">
                            <i class="fa fa-solid fa-eye"></i>
                        </button>&nbsp;
                        <button class="btn btn-sm btn-secondary" @click="copyMapsLink(item as any)"
                            :disabled="!(item as any).locations">
                            <i class="fa fa-solid fa-copy"></i>
                        </button>&nbsp;
                        <button class="btn btn-sm btn-warning" @click="statusSalesOrder(item as any)">
                            <i class="fa fa-brands fa-slack"></i>
                        </button>&nbsp;
                        <button v-if="role != 'WAREHOUSE'" class="btn btn-sm btn-danger"
                            @click="openInvoiceModal(item as any)">
                            <i class="fa fa-solid fa-print"></i>
                        </button>&nbsp;
                        <button class="btn btn-sm btn-info" @click="openWaybillModal(item as any)">
                            <i class="fa fa-solid fa-truck"></i>
                        </button>
                    </template>
                </DataTable>
            </div>
        </div>
    </div>

    <!-- Bootstrap Modal for Add/Edit -->
    <div class="modal fade" id="orderModal" tabindex="-1" ref="modalRef">
        <div class="modal-dialog modal-lg"> <!-- {{ Make modal larger for more fields }} -->
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ modalTitle }}</h5>
                    <button type="button" class="btn-close" @click="closeModal"></button>
                </div>
                <!-- <form @submit.prevent="saveOrder"> -->
                <div class="modal-body col-12">
                    <div class="row">
                        <div class="col-md-6 mb-2">
                            <label class="form-label col-form-label">Order Code</label>
                            <input v-model="form.code" type="text" class="form-control" disabled>
                        </div>
                        <div class="col-md-6 mb-2">
                            <label class="form-label col-form-label">Transaction Date</label>
                            <input v-if="role != 'WAREHOUSE'" v-model="form.transaction_date"
                                :disabled="form.order_status !== 'PENDING' && form.order_status !== 'APPROVED' && role == 'WAREHOUSE'"
                                class="form-control" type="datetime-local">
                            <input v-else v-model="form.transaction_date" disabled class="form-control"
                                type="datetime-local">
                        </div>
                    </div>
                    <div class="mb-2">
                        <label class="form-label col-form-label">Customer</label>
                        <input v-if="form.customer" :value="form.customer_name + ' (' + form.customer_phone + ')'"
                            type="text" class="form-control" disabled>
                    </div>
                    <div class="mb-2">
                        <label class="form-label col-form-label">Customer Address</label>
                        <textarea v-if="form.customer" v-model="form.customer_address" rows="3" class="form-control"
                            disabled />
                    </div>
                    <div class="mb-2">
                        <label class="form-label col-form-label">Location</label>
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-muted">Koordinat</div>
                                <div v-if="(form as any).locations" class="fw-semibold">{{ (form as any).locations }}</div>
                                <div v-else class="text-muted">Belum dipilih</div>
                            </div>
                            <div class="d-flex align-items-center">
                                <a v-if="(form as any).locations" class="btn btn-sm btn-outline-secondary me-2"
                                    target="_blank" rel="noopener noreferrer"
                                    :href="'https://www.google.com/maps?q=' + (form as any).locations">
                                    Open
                                </a>
                                <button class="btn btn-sm btn-outline-primary" @click="openLocationModal">
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4" style="overflow-y: auto;" v-if="role != 'WAREHOUSE'">
                        <h6>Order Items</h6>
                        <table class="table table-sm" v-if="form.ID && form.order_details.length > 0">
                            <thead>
                                <tr>
                                    <th>Produk</th>
                                    <th style="text-align:end">Qty</th>
                                    <th style="text-align:end">Harga</th>
                                    <th style="text-align:end">Diskon</th>
                                    <th style="text-align:end">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in form.order_details" :key="item.productId">
                                    <td>{{ item.name }}</td>
                                    <td style="text-align:end">{{ formatSeparator(item.quantity) }}</td>
                                    <td style="text-align:end">{{ formatCurrency(item.price) }}</td>
                                    <td style="text-align:end">{{ formatCurrency(item.discount) }}</td>
                                    <td style="text-align:end">{{ formatCurrency(item.total) }}</td>
                                </tr>
                                <tr>
                                    <td style="text-align:start; border: 0;">Admin : {{ session.getUser().nickname }}
                                    </td>
                                    <td colspan="3" style="text-align:end; border: 0;">Shipping Cost</td>
                                    <td style="text-align:end; border: 0;">{{ formatCurrency(form.shipping_cost) }}</td>
                                </tr>
                                <tr>
                                    <td style="text-align:start; border: 0;">Sales : {{ form.sales_name }}</td>
                                    <td colspan="3" style="text-align:end; border: 0;">Other Fee</td>
                                    <td style="text-align:end; border: 0;">{{ formatCurrency(form.fee_amount) }}</td>
                                </tr>
                                <tr>
                                    <td style="text-align:start; border: 0;"></td>
                                    <td colspan="3" style="text-align:end; border: 0;"></td>
                                    <td style="text-align:end; border: 0;"><b>{{ formatCurrency(form.grand_total) }}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p v-else>No items found for this order.</p>
                    </div>
                    <div class="row">
                        <div class="col-md-4" style="padding-left: 1rem;">
                            <label class="form-label me-4 mb-0">Bank</label>
                            <select v-model="form.bank" class="form-select">
                                <option :value="null" disabled>Select Bank</option>
                                <option v-for="option in bankOptions" :key="option.ID" :value="option">
                                    {{ option?.name }}
                                </option>
                            </select>
                        </div>
                        <div class=" col-md-8">
                            <label class="form-label me-4 mb-0" style="white-space: nowrap;">Bank
                                Account</label>
                            <select v-model="form.bank_account" class="form-select">
                                <option :value="null" disabled>Select Account</option>
                                <option v-for="option in bankAccountOptions" :key="option.ID" :value="option">
                                    {{ option.accountNumber }} - {{ option.accountName }} - {{
                                        option.branch
                                    }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row" v-if="role != 'WAREHOUSE'">
                        <div class="row col-md-5">
                            <div class="mb-2">
                                <label class="form-label col-form-label">Order Status</label>
                                <select class="form-select" v-model="form.order_status">
                                    <option value="PENDING">Pending</option>
                                    <option value="APPROVED">Approved</option>
                                    <option value="DELIVERY">Delivery</option>
                                    <option value="REJECTED">Rejected</option>
                                    <option value="CANCELLED">Cancelled</option>
                                </select>
                            </div>
                            <div class="mb-2">
                                <label class="form-label col-form-label">Note</label>
                                <textarea v-model="form.order_status_notes" col="3" class="form-control" />
                            </div>
                        </div>

                        <div class="row col-md-7">
                            <div class="mb-2">
                                <div v-if="form.payment_image" class="mt-2">
                                    <img :src="form.payment_image" alt="Preview"
                                        style="max-width: 300px; max-height: 300px;" @click="toggleZoom"
                                        :class="{ 'zoomed': isZoomed }">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer" v-if="role != 'WAREHOUSE'">
                    <button type="button" class="btn btn-danger" @click="closeModal">Cancel</button>
                    <button type="submit" class="btn btn-info" :disabled="paymentLoading"
                        @click="processOrder">Process</button>
                    <button
                        v-if="form.closed_date == null && (form.order_status == 'APPROVED' || form.order_status == 'DELIVERY')"
                        type="submit" class="btn btn-warning" :disabled="paymentLoading"
                        @click="processOrderClosing">Closed</button>
                    <button type="button" class="btn btn-success" @click="printWa">WA</button>
                </div>
                <!-- </form> -->
            </div>
        </div>
    </div>

    <div v-if="showLocationModal" class="modal fade show d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Update Location</h5>
                    <button type="button" class="btn-close" @click="closeLocationModal"></button>
                </div>
                <div class="modal-body">
                    <div class="row g-2">
                        <div class="col-12">
                            <div class="d-flex align-items-center justify-content-between">
                                <div>
                                    <div class="text-muted">Koordinat terpilih</div>
                                    <div v-if="tempLat != null && tempLng != null" class="fw-semibold">
                                        {{ tempLat }}, {{ tempLng }}
                                    </div>
                                    <div v-else class="text-muted">Klik peta atau cari alamat</div>
                                </div>
                                <button class="btn btn-outline-secondary btn-sm" @click="centerToTemp"
                                    :disabled="tempLat == null || tempLng == null">
                                    Center
                                </button>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="input-group">
                                <input type="text" class="form-control" v-model="addressQuery"
                                    placeholder="Cari alamat...">
                                <button class="btn btn-outline-primary" @click="searchAddress"
                                    :disabled="!addressQuery || !googleMapsApiKey">
                                    Search
                                </button>
                            </div>
                        </div>
                        <div class="col-12" v-if="googleMapsApiKey">
                            <GoogleMap :api-key="googleMapsApiKey" style="width: 100%; height: 420px"
                                :center="mapCenter" :zoom="mapZoom" @click="onMapClick">
                                <Marker v-if="tempLat != null && tempLng != null"
                                    :options="{ position: { lat: tempLat, lng: tempLng } }" />
                            </GoogleMap>
                        </div>
                        <div class="col-12" v-else>
                            <div class="alert alert-warning mb-0">
                                Google Maps API Key belum diset.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeLocationModal">Close</button>
                    <button type="button" class="btn btn-primary" @click="applyLocation">Use Location</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade" :class="{ 'show': showLocationModal }" v-if="showLocationModal"></div>

    <!-- Bootstrap Modal for Waybill -->
    <div class="modal fade" id="waybillModal" tabindex="-1" ref="waybillModalRef">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Print Waybill - {{ waybillForm.code }}</h5>
                    <button type="button" class="btn-close" @click="closeWaybillModal"></button>
                </div>
                <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
                    <div id="waybill-content" class="waybill-container waybill-modal-view">
                        <div class="waybill-header">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <p style="margin-bottom: 0.1rem"><strong>Order:</strong> {{
                                        waybillForm.shipping_name }}
                                    </p>
                                    <p style="margin-bottom: 0.1rem"><strong>Resi:</strong> {{ waybillForm.waybill_no ||
                                        'Belum ada resi' }}</p>
                                </div>
                                <div class="text-end">
                                    <p style="margin-bottom: 0.1rem"><strong>Order:</strong> {{ waybillForm.code }}</p>
                                    <p style="margin-bottom: 0.1rem"><strong>Date:</strong> {{
                                        formatDateTime(waybillForm.transaction_date) }}</p>
                                </div>
                            </div>
                        </div>

                        <div class="waybill-body flex-grow-1">
                            <div class="d-flex mb-2">
                                <div class="flex-fill me-2">
                                    <div class="sender-info">
                                        <h5>PENGIRIM</h5>
                                        <p><strong>{{ waybillForm.divisi_team_name }}</strong></p>
                                        <p>{{ waybillForm.sales_name }}</p>
                                    </div>
                                </div>
                                <div class="flex-fill ms-2">
                                    <div class="receiver-info">
                                        <h5>PENERIMA</h5>
                                        <p><strong>{{ waybillForm.customer_name }}</strong></p>
                                        <p>{{ waybillForm.customer_phone }}</p>
                                        <p>{{ waybillForm.customer_address }}</p>
                                        <p>{{ waybillForm.customer_city }}, {{ waybillForm.customer_province }}</p>
                                    </div>
                                </div>
                            </div>

                            <div class="package-info mb-2">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Produk</th>
                                            <th style="text-align:right">Qty</th>
                                            <th style="text-align:right">Price</th>
                                            <th style="text-align:right">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in waybillForm.order_details" :key="item.id">
                                            <td>{{ item.name }}</td>
                                            <td style="text-align:right">{{ item.quantity }}</td>
                                            <td style="text-align:right">{{ formatCurrency(item.price) }}</td>
                                            <td style="text-align:right">{{ formatCurrency(item.total) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <div class="shipping-info">
                                        <p><strong>Kurir:</strong> {{ waybillForm.courier_name }}</p>
                                        <p><strong>Layanan:</strong> {{ waybillForm.shipping_name }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6 cost-summary">
                                    <div class="row mb-1">
                                        <div class="col-6 text-end">
                                            <strong>Biaya Lain:</strong>
                                        </div>
                                        <div class="col-6 text-end">
                                            {{ formatCurrency(waybillForm.fee_amount) }}
                                        </div>
                                    </div>
                                    <div class="row mb-1">
                                        <div class="col-6 text-end">
                                            <strong>Ongkir:</strong>
                                        </div>
                                        <div class="col-6 text-end">
                                            {{ formatCurrency(waybillForm.shipping_cost) }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-6 text-end">
                                            <strong>Total:</strong>
                                        </div>
                                        <div class="col-6 text-end">
                                            {{ formatCurrency(waybillForm.grand_total) }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div class="signature-box flex-fill me-2">
                                <p>TTD Pengirim</p>
                                <div class="signature-line"></div>
                                <p>{{ waybillForm.sales_name }}</p>
                            </div>
                            <div class="signature-box flex-fill ms-2">
                                <p>TTD Penerima</p>
                                <div class="signature-line"></div>
                                <p>{{ waybillForm.customer_name }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeWaybillModal">Close</button>
                    <button type="button" class="btn btn-success" @click="printWaybillToPDF" :disabled="printLoading">
                        <i class="fa fa-file-pdf-o" v-if="!printLoading"></i>
                        <i class="fa fa-spinner fa-spin" v-else></i>
                        {{ printLoading ? 'Generating...' : 'Download PDF 4x6"' }}
                    </button>
                    <button type="button" class="btn btn-primary" @click="printWaybillToPNG" :disabled="printLoading">
                        <i class="fa fa-download" v-if="!printLoading"></i>
                        <i class="fa fa-spinner fa-spin" v-else></i>
                        {{ printLoading ? 'Generating...' : 'Download PNG' }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Bootstrap Modal for Invoice -->
    <div class="modal fade" id="invoiceModal" tabindex="-1" ref="invoiceModalRef">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Invoice - {{ invoiceForm.code }}</h5>
                    <button type="button" class="btn-close" @click="closeInvoiceModal"></button>
                </div>
                <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
                    <div id="invoice-content" class="invoice-container">
                        <!-- Header with teal background -->
                        <div class="invoice-header-bg">
                            <div class="invoice-header-content">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="invoice-title-section">
                                        <h1 class="invoice-main-title">INVOICE</h1>
                                    </div>
                                    <!-- <div class="company-logo">
                                        <div class="logo-icon">ds</div>
                                        <div class="logo-text">
                                            <span class="design-text">{{ invoiceForm.divisi_team_name }}</span>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>

                        <!-- Invoice details section -->
                        <div class="invoice-details-section">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="invoice-info-left">
                                        <p class="invoice-number"><strong>Invoice Number:</strong> {{ invoiceForm.code
                                            }}
                                        </p>
                                        <p class="invoice-date"><strong>Invoice Date:</strong> {{
                                            formatDate(invoiceForm.transaction_date) }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6 text-end">
                                    <div class="company-details">
                                        <img src="/gdn.png" alt="Gudang  Dunia" class="company-logo-img"
                                            style="max-height: 100px; max-width: 200px; object-fit: contain;">
                                        <!-- <p style="margin-top: 10px; font-size: 14px; color: #666;">{{ invoiceForm.divisi_team_name }}</p> -->
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Bill To Section -->
                        <div class="bill-to-section">
                            <!-- <h3 class="section-title">Bill To:</h3> -->
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="client-info">
                                        <p class="client-name"><strong>Customer: {{
                                            invoiceForm.customer_name.toUpperCase()
                                                }}</strong></p>
                                        <p class="phone"><strong>Phone:</strong> {{ invoiceForm.customer_phone }}</p>
                                        <p class="billing-address"><strong>Billing Address:</strong> {{
                                            invoiceForm.customer_address }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div v-if="invoiceForm.bank_name" class="payment-info">
                                        <h4>Payment Information:</h4>
                                        <p><strong>Bank:</strong> {{ invoiceForm.bank_name }}</p>
                                        <p><strong>Bank Account:</strong> {{ invoiceForm.bank_account_name }}</p>
                                        <p><strong>Bank Number:</strong> {{ invoiceForm.bank_account_number }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Service Details Section -->
                        <!-- <div class="service-details-section"> -->
                        <!-- <h3 class="section-title">Service Details:</h3> -->
                        <div class="service-table-container">
                            <table class="service-table">
                                <thead>
                                    <tr class="table-header">
                                        <th class="no-col">No</th>
                                        <th class="description-col">Description of Service</th>
                                        <th class="quantity-col">Product</th>
                                        <th class="rate-col">Price</th>
                                        <th class="total-col">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in invoiceForm.order_details" :key="item.id"
                                        class="table-row">
                                        <td class="no-col">{{ index + 1 }}</td>
                                        <td class="description-col">{{ item.name }}</td>
                                        <td class="quantity-col">{{ item.quantity }} Barang</td>
                                        <td class="rate-col">{{ formatCurrencyIDR(item.price) }}</td>
                                        <td class="total-col">{{ formatCurrencyIDR(item.total) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!-- </div> -->

                        <!-- Terms and Conditions & Total Section -->
                        <div class="row mt-4">
                            <div class="col-md-6">
                                <div class="terms-section">
                                    <h3 class="section-title">Terms and Conditions:</h3>
                                    <ul class="terms-list">
                                        <li>Payment is due upon receipt of this invoice.</li>
                                        <li>Late payments may incur additional charges.</li>
                                        <li>Shipping via {{ invoiceForm.shipping_name || 'Standard Shipping' }}.</li>
                                        <li>Courier service: {{ invoiceForm.courier_name || 'Regular Courier' }}.</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="total-calculation">
                                    <div class="subtotal-row">
                                        <span class="label">Subtotal</span>
                                        <span class="amount">{{ formatCurrencyIDR(calculateSubtotal()) }}</span>
                                    </div>
                                    <div class="subtotal-row">
                                        <span class="label">Courier</span>
                                        <span class="amount">{{ formatCurrencyIDR(invoiceForm.shipping_cost) }}</span>
                                    </div>
                                    <div class="tax-row">
                                        <span class="label">Other Fee</span>
                                        <span class="amount">{{ formatCurrencyIDR(invoiceForm.fee_amount) }}</span>
                                    </div>
                                    <div class="total-row">
                                        <span class="label"><strong>Total Amount Due</strong></span>
                                        <span class="amount"><strong>{{ formatCurrencyIDR(invoiceForm.grand_total)
                                                }}</strong></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Payment Information Section -->
                        <div class="payment-info-section">
                            <h3 class="section-title-white">Payment Information:</h3>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="payment-details">
                                        <p><strong>Payment Method:</strong> {{ invoiceForm.bank_name || 'Bank Transfer'
                                            }}
                                        </p>
                                        <p><strong>Due Date:</strong> {{ formatDate(invoiceForm.transaction_date) }}</p>
                                        <p><strong>Bank Account:</strong> {{ invoiceForm.bank_account_number ||
                                            '1234-5678-9012-3456' }}</p>
                                    </div>
                                </div>
                                <div class="col-md-6 text-end">
                                    <div class="signature-section">
                                        <p class="date-text">Date: {{ formatDate(invoiceForm.transaction_date) }}</p>
                                        <div class="signature-line"></div>
                                        <p class="signature-name">{{ invoiceForm.sales_name }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Questions Section -->
                        <!-- <div class="questions-section">
                            <h3 class="section-title">Questions</h3>
                            <div class="contact-info">
                                <p><strong>Email US:</strong> {{ invoiceForm.customer_email || 'designstudio@email.com' }}</p>
                                <p><strong>Call US:</strong> {{ invoiceForm.customer_phone || '(123) 456-7890' }}</p>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeInvoiceModal">Close</button>
                    <!-- <button type="button" class="btn btn-primary" @click="printInvoice">
                        <i class="fa fa-print"></i> Print Invoice
                    </button> -->
                    <button type="button" class="btn btn-success" @click="printInvoiceToPDF" :disabled="printLoading">
                        <i class="fa fa-file-pdf-o" v-if="!printLoading"></i>
                        <i class="fa fa-spinner fa-spin" v-else></i>
                        {{ printLoading ? 'Generating...' : 'Download PDF' }}
                    </button>
                    <button type="button" class="btn btn-info" @click="printInvoiceToPNG" :disabled="printLoading">
                        <i class="fa fa-download" v-if="!printLoading"></i>
                        <i class="fa fa-spinner fa-spin" v-else></i>
                        {{ printLoading ? 'Generating...' : 'Download PNG' }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Bootstrap Modal for Related Orders -->
    <div class="modal fade" id="relatedOrdersModal" tabindex="-1" ref="relatedOrdersModalRef">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Related Orders - {{ selectedOrder.code }}</h5>
                    <button type="button" class="btn-close" @click="closeRelatedOrdersModal"></button>
                </div>
                <div class="modal-body">
                    <div v-if="relatedOrdersLoading" class="text-center">
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <p class="mt-2">Loading related orders...</p>
                    </div>
                    <div v-else-if="relatedOrders.length === 0" class="text-center">
                        <p class="text-muted">No related orders found.</p>
                    </div>
                    <div v-else class="row">
                        <div class="col-md-6 col-lg-4 mb-3">
                            <div class="card h-100 border-primary">
                                <div
                                    class="card-header bg-warning text-white d-flex justify-content-between align-items-center">
                                    <h6 class="mb-0">{{ selectedOrder.code }}</h6>
                                    <h4 class="">ORIGINAL</h4>
                                </div>
                                <div class="card-body">
                                    <div class="mb-2">
                                        <strong>Customer:</strong> {{ selectedOrder.customer_name }}
                                    </div>
                                    <div class="mb-2">
                                        <strong>Phone:</strong> {{ selectedOrder.customer_phone }}
                                    </div>
                                    <div class="mb-2">
                                        <strong>Address:</strong> {{ selectedOrder.customer_address }}
                                    </div>
                                    <div class="mb-2">
                                        <strong>Date:</strong> {{ formatDateTime(selectedOrder.transaction_date) }}
                                    </div>
                                    <div class="mb-2">
                                        <strong>Status:</strong>
                                        <span :class="getStatusBadgeClass(selectedOrder.order_status)">{{
                                            selectedOrder.order_status
                                        }}</span>
                                    </div>
                                    <div class="mb-2">
                                        <strong>Total:</strong> {{ formatCurrency(selectedOrder.grand_total) }}
                                    </div>
                                    <div class="mb-2">
                                        <strong>Sales:</strong> {{ selectedOrder.sales_name }}
                                    </div>
                                    <div class="mb-2">
                                        <strong>Shipping:</strong> {{ selectedOrder.shipping_name }}
                                    </div>
                                    <div v-if="selectedOrder.order_details && selectedOrder.order_details.length > 0"
                                        class="mb-2">
                                        <strong>{{ selectedOrder.divisi_team_name }}:</strong>
                                        <ul class="list-unstyled mt-1">
                                            <li v-for="item in selectedOrder.order_details.slice(0, 3)" :key="item.id"
                                                class="small">
                                                - {{ item.name }} ({{ item.quantity }})
                                            </li>
                                            <li v-if="selectedOrder.order_details.length > 3" class="small text-muted">
                                                +{{ selectedOrder.order_details.length - 3 }} more items
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <button v-if="role != 'WAREHOUSE'" class="btn btn-sm btn-outline-primary"
                                        @click="viewOrderDetails(selectedOrder)">
                                        <i class="fa fa-eye"></i> View Details
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div v-for="dt in relatedOrders" :key="dt.order.ID" class="col-md-6 col-lg-4 mb-3">
                            <div class="card h-100 border-primary">
                                <div
                                    class="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                                    <h6 class="mb-0">{{ dt.order.code }}</h6>
                                    <h4 class="">{{ dt.similarity_score }}%
                                        Match</h4>
                                </div>
                                <div class="card-body">
                                    <div class="mb-2">
                                        <strong>Customer:</strong> {{ dt.order.customer_name }}
                                    </div>
                                    <div class="mb-2">
                                        <strong>Phone:</strong> {{ dt.order.customer_phone }}
                                    </div>
                                    <div class="mb-2">
                                        <strong>Address:</strong> {{ dt.order.customer_address }}
                                    </div>
                                    <div class="mb-2">
                                        <strong>Date:</strong> {{ formatDateTime(dt.order.transaction_date) }}
                                    </div>
                                    <div class="mb-2">
                                        <strong>Status:</strong>
                                        <span :class="getStatusBadgeClass(dt.order.order_status)">{{
                                            dt.order.order_status
                                        }}</span>
                                    </div>
                                    <div class="mb-2">
                                        <strong>Total:</strong> {{ formatCurrency(dt.order.grand_total) }}
                                    </div>
                                    <div class="mb-2">
                                        <strong>Sales:</strong> {{ dt.order.sales_name }}
                                    </div>
                                    <div class="mb-2">
                                        <strong>Shipping:</strong> {{ dt.order.shipping_name }}
                                    </div>
                                    <div v-if="dt.order.order_details && dt.order.order_details.length > 0"
                                        class="mb-2">
                                        <strong>{{ dt.order.divisi_team_name }}:</strong>
                                        <ul class="list-unstyled mt-1">
                                            <li v-for="item in dt.order.order_details.slice(0, 3)" :key="item.id"
                                                class="small">
                                                - {{ item.name }} ({{ item.quantity }})
                                            </li>
                                            <li v-if="dt.order.order_details.length > 3" class="small text-muted">
                                                +{{ dt.order.order_details.length - 3 }} more items
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <button v-if="role != 'WAREHOUSE'" class="btn btn-sm btn-outline-primary"
                                        @click="viewOrderDetails(dt.order)">
                                        <i class="fa fa-eye"></i> View Details
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeRelatedOrdersModal">Close</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, reactive, onMounted, watch } from 'vue'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import DataTable from '@/components/table/DatatableDateRange.vue'
import { Modal } from 'bootstrap'
import * as sales from '@/api/services/SalesRequest'
import * as master from '@/api/services/MasterRequest'
import { GoogleMap, Marker } from 'vue3-google-map'
import { useSessionStore } from '@/store/session';
const session = useSessionStore()
const role = session.getUser().role
const divisiOptions = ref<{ ID: any }[]>([])
const divisiTeamOptions = ref<{ ID: any, name: string }[]>([])
const shippingOptions = ref<{ ID: any, name: string }[]>([])
const courierOptions = ref<{ ID: any, name: string }[]>([])

const bankOptions = ref<{ ID: any, name: string, accounts?: any[] }[]>([])
const bankAccountOptions = ref<{ ID: any, accountNumber: string, accountName: string, branch: string }[]>([])

// {{ Define SalesOrder interface }}
interface SalesOrder {
    id: number | null; // Allow null for new salesOrders
    code: string;
    name: string;
}

let headers = [
    { text: '#Act', value: 'actions', freeze: true },
    { text: 'Divisi', value: 'divisi_team_name' },
    { text: 'Order No', value: 'code' },
    { text: 'Transaction Date', value: 'transaction_date' },
    { text: 'Customer', value: 'customer_name' },
    { text: 'Shipping', value: 'shipping_name' },
    { text: 'Courier', value: 'courier_name' },
    { text: 'Product', value: 'order_details' },
    { text: 'Order Status', value: 'order_status' },
    { text: 'Resi', value: 'waybill_no' },
    { text: 'Grand Total', value: 'grand_total' },
    { text: 'Sales', value: 'sales_name' },
    { text: 'Bank', value: 'bank_name' },
    { text: 'Customer Information', value: 'customer_data' },
    { text: 'Description', value: 'description' },
]
if (role == 'WAREHOUSE') {
    headers = [
        { text: '#Act', value: 'actions' },
        { text: 'Divisi', value: 'divisi_team_name' },
        { text: 'Order No', value: 'code' },
        { text: 'Transaction Date', value: 'transaction_date' },
        { text: 'Customer', value: 'customer_name' },
        { text: 'Shipping', value: 'shipping_name' },
        { text: 'Courier', value: 'courier_name' },
        { text: 'Order Status', value: 'order_status' },
        { text: 'Resi', value: 'waybill_no' },
        { text: 'Product', value: 'order_details' },
        { text: 'Customer Information', value: 'customer_data' },
    ]
}

let form = reactive({
    ID: null,
    code: null,
    divisi: null as any | null,
    divisi_team: null as any | null,
    transaction_date: null as Date | null,
    customer: null as any | null,
    order_details: [] as any[],
    shipping: null as any | null,
    courier: null as any | null,
    courier_name: '',
    bank: null as any | null,
    bank_account: null as any | null,
    payment: 'TRANSFER',
    payment_image: null as any | null,
    shipping_cost: 0 as number,
    qty_total: 0 as number,
    sub_total: 0 as number,
    fee_amount: 0 as number,
    grand_total: 0 as number,
    locations: '' as any,
    status: 'PENDING', // default agar tidak null
    order_status: null as string | null,
    order_status_by: null as string | null,
    order_status_notes: null as string | null,
    sales_email: null as string | null,
    sales_name: null as string | null,
    sales: null as any | null,
    closed_date: null as any | null,
    approval_by: null as any | null,
    approval_date: null as any | null,
    approval_notes: null as any | null,
    reject_by: null as any | null,
    reject_date: null as any | null,
    reject_notes: null as any | null,
    cancel_by: null as any | null,
    cancel_date: null as any | null,
    cancel_notes: null as any | null,
    description: null as any | null,
});

function itemDetail(item: any) {
    try {
        return item.map((detail: { name: string; quantity: number }) =>
            `${detail.name} (${detail.quantity})`
        ).join('<br>');
    } catch (error) {
        console.error('Error formatting item details:', error);
        return '';
    }
}
// {{ Apply types to refs and reactive objects }}
const salesOrders = ref<SalesOrder[]>([])
const loading = ref(false)
const total = ref(0)
const params = reactive<DataTableParams>({
    page: 1,
    size: 10,
    search: '',
    status: '',
    divisi_id: session.divisionOptions().find(d => d.name === session.getUser().divisi)?.ID,
    divisi_team_id: '',
    shipping_id: '',
    courier_id: '',
    closed: '',
})

// Related Orders Modal
const relatedOrders = ref([])
const relatedOrdersLoading = ref(false)
const relatedOrdersModalRef = ref(null)
const selectedOrder = ref({})

// Tambahkan watch untuk bank, agar bankAccountOptions diupdate sesuai bank yang dipilih
watch(() => form.bank, (val) => {
    if (val && val.accounts) {
        bankAccountOptions.value = val.accounts
    } else {
        bankAccountOptions.value = []
    }
    form.bank_account = null // reset account selection when bank changes
}, { deep: true })
watch(() => form.status, (newVal) => {
    params.status = newVal
})
watch(() => params.divisi_id, (newVal) => {
    params.divisi_id = newVal ? newVal : null;
    divisiTeamOptions.value = session.divisionOptions().find(d => d.ID === params.divisi_id).divisiTeams
    params.divisi_team_id = '' // reset  selection
    console.log(divisiTeamOptions.value)
});
// watch(() => form.divisi_team, (newVal) => {
//     params.divisi_team_id = newVal ? newVal.ID : null;
// });
watch(() => params.shipping_id, (newVal) => {
    params.courier_id = ''
    courierOptions.value = shippingOptions.value.find(s => s.ID === newVal)?.couriers
});
// watch(() => form.divisi, (newDivisi) => {
//     if (newDivisi && newDivisi.divisiTeams) {
//         divisiTeamOptions.value = newDivisi.divisiTeams
//         form.divisi_team = null // reset  selection
//     } else {
//         divisiTeamOptions.value = []
//         form.divisi_team = null
//     }
// })
const modalTitle = ref('')

const fetchSalesOrders = async () => {
    loading.value = true
    try {
        // Simulate API delay
        const paramsTemp = { ...params }
        if (paramsTemp.status && Array.isArray(paramsTemp.status)) {
            paramsTemp.status = paramsTemp.status.map(s => s.code).join(',')
        }
        await sales.postRequest("/sales-order/list", paramsTemp).then((response) => {
            salesOrders.value = response.data;
            total.value = response.total
        });

    } catch (error) {
        toast.error('Failed to fetch salesOrders')
    }
    loading.value = false
}

const fetchShipping = async () => {
    loading.value = true
    try {
        // Simulate API delay
        await master.postRequest("/shipping/list", params).then((response) => {
            shippingOptions.value = response.data;
        });

    } catch (error) {
        toast.error('Failed to fetch salesOrders')
    }
    loading.value = false
}

function printWa() {
    loading.value = true
    const selectedOrder = { ...form }
    if (selectedOrder) {
       let reportWhatsapp = "";
        reportWhatsapp += "\r\n *LAPORAN PEMESANAN  " + selectedOrder.shipping_name.toUpperCase() + "*";
        // reportWhatsapp += "\r\n *Divisi  : " + selectedOrder.divisi_name.toUpperCase() + "*";
        reportWhatsapp += "\r\n *Divisi Team  : " + selectedOrder.divisi_team_name.toUpperCase() + "*";
        reportWhatsapp += "\r\n *IKLAN  : " + selectedOrder.interaction_name + "*";
        reportWhatsapp += "\r\n *Tanggal  : " + formatDateTime(selectedOrder.transaction_date) + "*";
        reportWhatsapp += "\r\n ";
        reportWhatsapp += "\r\n *TANGGAL ORDER KE ADMIN:*";
        reportWhatsapp += "\r\n *" + formatDate(new Date().toISOString()) + "*";
        reportWhatsapp += "\r\n *JAM ORDER KE ADMIN:*";
        reportWhatsapp += "\r\n *" + new Date().toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Jakarta' }) + " WIB*";
        reportWhatsapp += "\r\n ";
        reportWhatsapp += "\r\n *Berikut data pengiriman pemesanan customer:*";
        reportWhatsapp += "\r\n -Nama Pembeli: " + selectedOrder.customer_name;
        reportWhatsapp += "\r\n -No. Telp: " + selectedOrder.customer_phone;
        reportWhatsapp += "\r\n -Alamat: " + selectedOrder.customer_address;
        reportWhatsapp += "\r\n";
        reportWhatsapp += "\r\n *Berikut data Pesanan: " + (selectedOrder.order_details && selectedOrder.order_details[0] ? selectedOrder.order_details[0].name : 'N/A') + "*";
        reportWhatsapp += "\r\n -No. Pesanan : " + selectedOrder.code;
        reportWhatsapp += "\r\n -Jumlah Pemesanan : " + formatSeparator(selectedOrder.order_details && selectedOrder.order_details[0] ? selectedOrder.order_details[0].quantity : 0);
        reportWhatsapp += "\r\n -Biaya Diskon : " + formatSeparator(selectedOrder.order_details && selectedOrder.order_details[0] ? selectedOrder.order_details[0].discount : 0);
        reportWhatsapp += "\r\n -Biaya Pengiriman : " + formatSeparator(selectedOrder.shipping_cost || 0);
        reportWhatsapp += "\r\n -Biaya Penanganan : " + formatSeparator(selectedOrder.fee_amount || 0);
        reportWhatsapp += "\r\n -Total Pembayaran : " + formatSeparator(selectedOrder.grand_total);
        reportWhatsapp += "\r\n -Bank   : " + selectedOrder.bank_name;
        reportWhatsapp += "\r\n -Jenis transaksi : " + selectedOrder.payment;
        reportWhatsapp += "\r\n -Kurir Pengiriman : " + selectedOrder.courier_name;
        reportWhatsapp += "\r\n -Tanggal Order : " + formatDateTime(selectedOrder.transaction_date);
        reportWhatsapp += "\r\n -No. Resi: " + (selectedOrder.waybill_no || 'N/A');
        reportWhatsapp += "\r\n -Status Pemesanan: " + selectedOrder.order_status;
        reportWhatsapp += "\r\n ";
        reportWhatsapp += "\r\n ";
        reportWhatsapp += "\r\n *CS YANG MENGAJUKAN CS "+ selectedOrder.divisi_team_name.toUpperCase()+"*";
        reportWhatsapp += "\r\n Nama : "+selectedOrder.sales_name;
        reportWhatsapp += "\r\n ";
        reportWhatsapp += "\r\n *ACC✅*";
        reportWhatsapp += "\r\n ADMIN PRODUK ";
        reportWhatsapp += "\r\n Nama : " + selectedOrder.approval_by;
        reportWhatsapp += "\r\n ";
        reportWhatsapp += "\r\n *MENGETAHUI*";
        reportWhatsapp += "\r\n FINANCE";
        reportWhatsapp += "\r\n ";
        // reportWhatsapp += "\r\n ";
        // reportWhatsapp += "\r\n *YANG BERTANGGUNG JAWAB*";  
        // reportWhatsapp += "\r\n DIREKTUR " ;
        // reportWhatsapp += "\r\n BU IRA " ;
        reportWhatsapp += "\r\n " ;


        // Create temporary textarea element
        const tempTextArea = document.createElement('textarea');
        const modalElement = document.getElementById('orderModal');
        if (modalElement) {
            // tempTextArea.style.cssText = 'position: fixed; left: -9999px; top: 0';
            tempTextArea.setAttribute('readonly', ''); // Prevent mobile keyboard from showing
            modalElement.appendChild(tempTextArea);
            tempTextArea.value = reportWhatsapp;

            // Copy text
            tempTextArea.focus();
            tempTextArea.select();
        }
        try {
            document.execCommand('copy');
            toast.success('Copy Success');
        } catch (err) {
            toast.warning('Oops, unable to copy');
        }
        // Clean up
        if (modalElement && tempTextArea) {
            modalElement.removeChild(tempTextArea);
        }
    }
    loading.value = false
}

async function printRekapWa() {
    loading.value = true;

    // Simulate API delay
    const paramsTemp = { ...params }
    if (paramsTemp.status && Array.isArray(paramsTemp.status)) {
        paramsTemp.status = paramsTemp.status.map(s => s.code).join(',')
    }
    let temp = await sales.postRequest("/sales-order/list", paramsTemp);
    let divisionTeamSales = {}
    let reportWhatsapp = "";
    if (temp) {
        let listSO = temp.data;
        listSO.forEach(data => {
            divisionTeamSales[data.divisi_team_name] = !divisionTeamSales[data.divisi_team_name] ? [] : divisionTeamSales[data.divisi_team_name];
            for (const property in divisionTeamSales) {
                if (property == data.divisi_team_name) {
                    divisionTeamSales[data.divisi_team_name].push(data);
                }
            }
        });

        for (const property in divisionTeamSales) {
            let transactionSales = {}
            let totalSales = {
                shipping_name: "",
                quantity: 0,
                totalAmount: 0,
                courierAmount: 0,
                feeAmount: 0,
                grandTotalAmount: 0,
            }
            divisionTeamSales[property].forEach(data => {
                // Calculate total quantity from order_details
                totalSales.shipping_name = data.shipping_name
                let orderQuantity = parseInt(data.qty_total);
                totalSales.quantity = parseInt(data.qty_total) + parseInt(totalSales.quantity);
                totalSales.totalAmount = parseInt(data.sub_total) + parseInt(totalSales.totalAmount);
                totalSales.courierAmount = parseInt(data.shipping_cost) + parseInt(totalSales.courierAmount);
                totalSales.feeAmount = parseInt(data.fee_amount) + parseInt(totalSales.feeAmount);
                totalSales.grandTotalAmount = parseInt(data.grand_total) + parseInt(totalSales.grandTotalAmount);
                transactionSales[data.sales_name] = !transactionSales[data.sales_name] ? [] : transactionSales[data.sales_name];
                for (const sales in transactionSales) {
                    if (sales == data.sales_name) {
                        transactionSales[data.sales_name].push(data);
                    }
                }
            });

            reportWhatsapp += "\r\n *Laporan Kerja Marketing Harian*";
            reportWhatsapp += "\r\n *Divisi  : " + property.toUpperCase() + "*";
            reportWhatsapp += "\r\n *Nama Admin  : " + session.getUser().nickname + "*";
            reportWhatsapp += "\r\n *Tanggal  : " + formatDateTime(params.start_date) + " - " + formatDateTime(params.end_date) + "*";
            reportWhatsapp += "\r\n ";

            reportWhatsapp += "\r\n #Total All Barang: " + totalSales.quantity;
            reportWhatsapp += "\r\n #Total All Total: Rp. " + formatSeparator(totalSales.totalAmount) + "";
            reportWhatsapp += "\r\n #Total All Ongkir: Rp. " + formatSeparator(totalSales.courierAmount) + "";
            reportWhatsapp += "\r\n #Total All Penanganan: Rp. " + formatSeparator(totalSales.feeAmount) + "";
            reportWhatsapp += "\r\n #Total All Transaksi: Rp. " + formatSeparator(totalSales.grandTotalAmount) + "";
            reportWhatsapp += "\r\n ========================";
            reportWhatsapp += "\r\n Type Transaksi : " + totalSales.shipping_name;

            let s = 1;
            for (const property in transactionSales) {
                reportWhatsapp += "\r\n ";
                reportWhatsapp += "\r\n  " + s + ".) Sales Marketing : " + property;
                let i = 1;
                let listTransaction = '';
                let totalTransaction = {
                    quantity: 0,
                    totalAmount: 0,
                    courierAmount: 0,
                    feeAmount: 0,
                    grandTotalAmount: 0,
                }
                transactionSales[property].forEach(datas => {
                    // Calculate quantity from order_details
                    let orderQuantity = datas.qty_total;

                    totalTransaction.quantity = parseInt(datas.qty_total) + parseInt(totalTransaction.quantity);
                    totalTransaction.totalAmount = !totalTransaction.totalAmount ? parseInt(datas.sub_total || 0) : parseInt(datas.sub_total || 0) + parseInt(totalTransaction.totalAmount);
                    totalTransaction.courierAmount = !totalTransaction.courierAmount ? parseInt(datas.shipping_cost || 0) : parseInt(datas.shipping_cost || 0) + parseInt(totalTransaction.courierAmount);
                    totalTransaction.feeAmount = !totalTransaction.feeAmount ? parseInt(datas.fee_amount || 0) : parseInt(datas.fee_amount || 0) + parseInt(totalTransaction.feeAmount);
                    totalTransaction.grandTotalAmount = !totalTransaction.grandTotalAmount ? parseInt(datas.grand_total || 0) : parseInt(datas.grand_total || 0) + parseInt(totalTransaction.grandTotalAmount);

                    // Calculate discount from order_details
                    let discountAmount = 0;
                    if (datas.order_details && Array.isArray(datas.order_details)) {
                        datas.order_details.forEach(detail => {
                            discountAmount += parseInt(detail.discount || 0);
                        });
                    }
                    const status = datas.close_date ? 'Close' : 'Open';

                    listTransaction += "\r\n      " + i + ".) Nama   : " + (datas.customer_name || '');
                    listTransaction += "\r\n        - Telp      : " + (datas.customer_phone || '');
                    listTransaction += "\r\n        - Jumlah    : " + orderQuantity;
                    listTransaction += "\r\n        - Voucher   : Rp. " + discountAmount;
                    listTransaction += "\r\n        - Total   : Rp. " + (datas.sub_total || 0);
                    listTransaction += "\r\n        - Ongkir   : Rp. " + (datas.shipping_cost || 0);
                    listTransaction += "\r\n        - Penanganan   : Rp. " + (datas.fee_amount || 0);
                    listTransaction += "\r\n        - Grand Total  : Rp. " + (datas.grand_total || 0);
                    listTransaction += "\r\n        - Bank      : " + (datas.bank_name + ' ' + datas.bank_account_name + '/ ' + datas.bank_account_number || '');
                    listTransaction += "\r\n        - Nama CS      : " + (datas.sales_name || '');
                    listTransaction += "\r\n        - Description  : " + status + " - " + (datas.interaction_name + " - " + datas.description || '') ;
                    i++
                });
                reportWhatsapp += "\r\n      #Total All Barang: " + totalTransaction.quantity;
                reportWhatsapp += "\r\n      #Total All Total: Rp. " + formatSeparator(totalTransaction.totalAmount) + "";
                reportWhatsapp += "\r\n      #Total All Ongkir: Rp. " + formatSeparator(totalTransaction.courierAmount) + "";
                reportWhatsapp += "\r\n      #Total All Penanganan: Rp. " + formatSeparator(totalTransaction.feeAmount) + "";
                reportWhatsapp += "\r\n      #Total All Transaksi: Rp. " + formatSeparator(totalTransaction.grandTotalAmount) + "";
                reportWhatsapp += "\r\n      ";
                reportWhatsapp += listTransaction;
                s++
            }
            reportWhatsapp += "\r\n ";
            reportWhatsapp += "\r\n ";

        }
    }

    let divisionLabel = ""
    if (reportWhatsapp === '') {
        reportWhatsapp += "\r\n *Laporan Kerja Marketing Harian*";
        reportWhatsapp += "\r\n *Divisi  : " + divisionLabel.toUpperCase() + "*";
        reportWhatsapp += "\r\n *Nama Admin  : " + store.state.profile.nickname + "*";
        reportWhatsapp += "\r\n *Tanggal  : " + formatDateTime(params.start_date) + " - " + formatDateTime(params.end_date) + "*";
        reportWhatsapp += "\r\n ";

        reportWhatsapp += "\r\n #Total All Barang: " + 0;
        reportWhatsapp += "\r\n #Total All Total: Rp. " + 0 + "";
        reportWhatsapp += "\r\n #Total All Ongkir: Rp. " + 0 + "";
        reportWhatsapp += "\r\n #Total All Penanganan: Rp. " + 0 + "";
        reportWhatsapp += "\r\n #Total All Transaksi: Rp. " + 0 + "";
        reportWhatsapp += "\r\n ========================";
    }

    // Create temporary textarea element
    const tempTextArea = document.createElement('textarea');
    const modalElement = document.getElementById('body-salesorder');
    if (modalElement) {
        // tempTextArea.style.cssText = 'position: fixed; left: -9999px; top: 0';
        tempTextArea.setAttribute('readonly', ''); // Prevent mobile keyboard from showing
        modalElement.appendChild(tempTextArea);
        tempTextArea.value = reportWhatsapp;

        // Copy text
        tempTextArea.focus();
        tempTextArea.select();
    }
    try {
        document.execCommand('copy');
        toast.success('Copy Success');
    } catch (err) {
        toast.warning('Oops, unable to copy');
    }
    // Clean up
    if (modalElement && tempTextArea) {
        modalElement.removeChild(tempTextArea);
    }
    loading.value = false;
}
const processDownload = async () => {
    loading.value = true
    try {
        // Simulate API delay
        const prms = { ...params }
        if (prms.status && Array.isArray(prms.status)) {
            prms.status = prms.status.map(s => s.code).join(',')
        }
        prms.start_date = new Date(params.start_date).toLocaleString('sv-SE', { timeZone: 'Asia/Jakarta' }).replace(' ', 'T')+"+07:00"
        prms.end_date = new Date(params.end_date).toLocaleString('sv-SE', { timeZone: 'Asia/Jakarta' }).replace(' ', 'T')+"+07:00"
        prms.size = 100000
        try {
            const response = await sales.getDownload("/sales-order/xlsx", prms);
            // Create blob from response data
            const blob = new Blob([response], { type: 'application/vnd.ms-excel' });
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'sales-orders.xlsx');
            // Trigger download
            document.body.appendChild(link);
            link.click();
            // Cleanup
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading file:', error);
            toast.error('Failed to download file. Please try again.');
        }

    } catch (error) {
        toast.error('Failed to fetch salesOrders')
    }
    loading.value = false
}

import * as ExcelJS from 'exceljs'
const processDownloadJnt = async () => {
    loading.value = true
    try {
        try {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Delivery Details');

            // Set up headers
            worksheet.columns = [
                { header: 'Berat', key: 'weight', width: 10 },
                { header: 'Nama Pengirim', key: 'sender_name', width: 20 },
                { header: 'Telepon Pengirim', key: 'sender_phone', width: 15 },
                { header: 'Provinsi Pengirim', key: 'sender_province', width: 15 },
                { header: 'Kota Pengirim', key: 'sender_city', width: 15 },
                { header: 'Daerah Pengirim', key: 'sender_district_info', width: 15 },
                { header: 'Alamat Pengirim', key: 'sender_address', width: 30 },
                { header: 'Informasi Alamat Pengirim', key: 'sender_address_info', width: 30 },
                { header: 'Apakah Dropship?', key: 'is_dropship', width: 15 },
                { header: 'Nama Dropshiper', key: 'dropshipper_name', width: 20 },
                { header: 'Telfon Dropshiper', key: 'dropshipper_phone', width: 15 },
                { header: 'Nama Penerima', key: 'receiver_name', width: 20 },
                { header: 'Telepon Penerima', key: 'receiver_phone', width: 15 },
                { header: 'Provinsi Penerima', key: 'receiver_province', width: 15 },
                { header: 'Kota Penerima', key: 'receiver_city', width: 15 },
                { header: 'Kecamatan', key: 'receiver_district', width: 15 },
                { header: 'Alamat Penerima', key: 'receiver_address', width: 30 },
                { header: 'Informasi Alamat Penerima', key: 'receiver_address_info', width: 30 },
                { header: 'Cara Pembayaran', key: 'payment_method', width: 15 },
                { header: 'Nama Barang', key: 'product_name', width: 20 },
                { header: 'Kategori Barang', key: 'product_category', width: 20 },
                { header: 'Nilai Barang', key: 'product_value', width: 15 },
                { header: 'Jenis asuransi', key: 'insurance_type', width: 15 },
                { header: 'Apakah Input Asuransi?', key: 'has_insurance', width: 20 },
                { header: 'Jumlah', key: 'quantity', width: 10 },
                { header: 'Jenis Barang', key: 'product_type', width: 15 },
                { header: 'Keterangan', key: 'notes', width: 20 },
                { header: 'Nomor pesanan e-commerce', key: 'ecommerce_order_number', width: 25 },
                { header: 'COD', key: 'is_cod', width: 10 },
                { header: 'Jenis Layanan', key: 'service_type', width: 15 },
                { header: 'Biaya Pengiriman', key: 'shipping_cost', width: 15 },
                { header: 'Biaya Lainnya', key: 'other_costs', width: 15 }
            ];

            // Add data rows
            salesOrders.value.forEach((detail: any) => {
                if (detail.waybill_no == "") {
                    if (detail.waybill_no == '') {
                        worksheet.addRow({
                            weight: 1,
                            sender_name: detail.divisi_team_name || '',
                            sender_phone: '08111758115',
                            sender_city: 'CIPUTAT',
                            sender_province: 'BANTEN',
                            sender_district_info: 'Kec. Pd. Aren',
                            sender_address: 'Jl. H. Basir No.128, RT.4/RW.2, Pd. Kacang Bar., Kec. Pd. Aren, Kota Tangerang Selatan, Banten 15226',
                            sender_address_info: '',
                            is_dropship: 0,
                            dropshipper_name: '',
                            dropshipper_phone: '',
                            receiver_name: detail.customer_name || '',
                            receiver_phone: detail.customer_phone || '',
                            receiver_province: detail.customer_province || '',
                            receiver_city: detail.customer_area || '',
                            receiver_address: detail.customer_address || '',
                            receiver_address_info: '',
                            payment_method: 'BULANAN',
                            product_name: detail.order_details[0].name || '',
                            product_category: detail.order_details[0].category || '',
                            product_value: detail.sub_total || 0,
                            insurance_type: detail.insurance_type || '',
                            has_insurance: 1,
                            quantity: detail.qty_total || 0,
                            product_type: 'BARANG',
                            notes: detail.notes || '',
                            ecommerce_order_number: detail.code || '',
                            is_cod: detail.shipping_id == 1 ? detail.grand_total : '',
                            service_type: 'EZ',
                            shipping_cost: detail.shipping_cost || 0,
                            other_costs: ''
                        });
                    }
                }
            });

            // Style the header row
            worksheet.getRow(1).font = { bold: true };
            worksheet.getRow(1).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFE0E0E0' }
            };

            // Generate file
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);

            // Trigger download
            const link = document.createElement('a');
            link.href = url;
            link.download = `JNT_delivery.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            toast.error('Failed to export JNT')
            console.log(error)
        }

    } catch (error) {
        toast.error('Failed to fetch salesOrders')
    }
    loading.value = false
}

// {{ Add type annotation for newParams }}
const updateParams = (newParams: Partial<DataTableParams>) => {
    Object.assign(params, newParams)
    fetchSalesOrders()
}

const modalRef = ref<HTMLElement | null>(null) // Type the ref
let bsModal: any | null = null // Type the bootstrap modal instance as any since Modal namespace can't be used directly
onMounted(() => {
    divisiOptions.value = session.divisionOptions()
    divisiTeamOptions.value = session.divisionOptions().find(d => d.name === session.getUser().divisi)?.divisiTeams
    if (modalRef.value) { // Check if modalRef exists
        bsModal = new Modal(modalRef.value)
    }
    if (waybillModalRef.value) { // Initialize waybill modal
        bsWaybillModal = new Modal(waybillModalRef.value)
    }
    if (invoiceModalRef.value) { // Initialize invoice modal
        bsInvoiceModal = new Modal(invoiceModalRef.value)
    }
    fetchShipping()
    fetchBank()
})

const fetchBank = async () => {
    try {
        const resp = await master.postRequest("/bank/list", { page: 1, size: 10000, search: '' });
        bankOptions.value = resp.data;
    } catch (error) {
        toast.error('Failed to fetch customers')
    }
}
let paymentLoading = ref(false)
const googleMapsApiKey = (import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string | undefined) || ''
const showLocationModal = ref(false)
const tempLat = ref<number | null>(null)
const tempLng = ref<number | null>(null)
const mapCenter = ref<{ lat: number, lng: number }>({ lat: -6.200000, lng: 106.816666 })
const mapZoom = ref(13)
const addressQuery = ref('')
async function processOrder() {
    let formTemp = { ...form }
    paymentLoading.value = true
    const dates = formTemp.transaction_date ? new Date(formTemp.transaction_date).toISOString() : new Date().toISOString();
    formTemp.description = formTemp.order_status_notes
    formTemp.bank = formTemp.bank
    formTemp.bank_account = formTemp.bank_account
    if (formTemp.order_status == "APPROVED") {
        await sales.postRequest("/sales-order/update-payment", {
            ID: formTemp.ID,
            transaction_date: dates,
            order_status: formTemp.order_status,
            locations: formTemp.locations,
            approval_by: session.getUser().nickname,
            approval_date: new Date(),
            approval_notes: formTemp.order_status_notes,
            description: formTemp.order_status_notes,
            bank: formTemp.bank,
            bank_account: formTemp.bank_account,
        })
    } else if (formTemp.order_status == "REJECTED") {
        await sales.postRequest("/sales-order/update-payment", {
            ID: formTemp.ID,
            transaction_date: dates,
            order_status: formTemp.order_status,
            locations: formTemp.locations,
            reject_by: session.getUser().nickname,
            reject_date: new Date(),
            reject_notes: formTemp.order_status_notes,
            description: formTemp.order_status_notes,
            bank: formTemp.bank,
            bank_account: formTemp.bank_account,

        })
    } else if (formTemp.order_status == "CANCELLED") {
        await sales.postRequest("/sales-order/update-payment", {
            ID: formTemp.ID,
            transaction_date: dates,
            order_status: formTemp.order_status,
            locations: formTemp.locations,
            cancel_by: session.getUser().nickname,
            cancel_date: new Date(),
            cancel_notes: formTemp.order_status_notes,
            description: formTemp.order_status_notes,
            bank: formTemp.bank,
            bank_account: formTemp.bank_account,
        })
    } else {
        await sales.postRequest("/sales-order/update-payment", {
            ID: formTemp.ID,
            transaction_date: dates,
            order_status: formTemp.order_status,
            locations: formTemp.locations,
            description: formTemp.order_status_notes,
            bank: formTemp.bank,
            bank_account: formTemp.bank_account,
        })
    }
    paymentLoading.value = false
    closeModal()
    fetchSalesOrders()
}

function parseLocation(value: string): { lat: number | null, lng: number | null } {
    if (!value) return { lat: null, lng: null }
    const parts = value.split(',').map((v: string) => v.trim())
    if (parts.length < 2) return { lat: null, lng: null }
    const lat = Number(parts[0])
    const lng = Number(parts[1])
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return { lat: null, lng: null }
    return { lat, lng }
}

function openLocationModal() {
    const parsed = parseLocation(form.locations || '')
    tempLat.value = parsed.lat
    tempLng.value = parsed.lng
    addressQuery.value = form.customer_address || ''
    if (tempLat.value != null && tempLng.value != null) {
        mapCenter.value = { lat: tempLat.value, lng: tempLng.value }
        mapZoom.value = 16
    }
    showLocationModal.value = true
    if (tempLat.value == null && tempLng.value == null && addressQuery.value) {
        searchAddress(true)
    }
}

function closeLocationModal() {
    showLocationModal.value = false
}

function applyLocation() {
    if (tempLat.value == null || tempLng.value == null) {
        form.locations = ''
        showLocationModal.value = false
        return
    }
    form.locations = `${tempLat.value},${tempLng.value}`
    showLocationModal.value = false
}

function centerToTemp() {
    if (tempLat.value == null || tempLng.value == null) return
    mapCenter.value = { lat: tempLat.value, lng: tempLng.value }
    mapZoom.value = 16
}

function onMapClick(e: any) {
    const lat = e?.latLng?.lat?.()
    const lng = e?.latLng?.lng?.()
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return
    tempLat.value = Number(lat)
    tempLng.value = Number(lng)
}

async function searchAddress(silent: boolean = false) {
    if (!addressQuery.value) return
    if (!googleMapsApiKey) {
        if (!silent) toast.error('Google Maps API Key belum diset')
        return
    }
    const googleObj = (window as any).google
    if (!googleObj?.maps?.Geocoder) {
        if (silent) {
            retrySearchAddress(10)
            return
        }
        toast.error('Google Maps belum siap')
        return
    }

    const geocoder = new googleObj.maps.Geocoder()
    geocoder.geocode({ address: addressQuery.value }, (results: any, status: any) => {
        if (status !== 'OK' || !results || results.length === 0) {
            if (!silent) toast.error('Alamat tidak ditemukan')
            return
        }
        const loc = results[0]?.geometry?.location
        const lat = loc?.lat?.()
        const lng = loc?.lng?.()
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
            if (!silent) toast.error('Koordinat tidak valid')
            return
        }
        tempLat.value = Number(lat)
        tempLng.value = Number(lng)
        mapCenter.value = { lat: tempLat.value, lng: tempLng.value }
        mapZoom.value = 16
    })
}

function retrySearchAddress(triesLeft: number) {
    if (triesLeft <= 0) return
    setTimeout(() => {
        const googleObj = (window as any).google
        if (googleObj?.maps?.Geocoder) {
            searchAddress(true)
            return
        }
        retrySearchAddress(triesLeft - 1)
    }, 250)
}

async function processOrderClosing() {
    paymentLoading.value = true
    let formTemp = { ...form }
    formTemp.transaction_date = formTemp.transaction_date ? new Date(formTemp.transaction_date).toISOString() : new Date().toISOString();
    await sales.postRequest("/sales-closing/order", formTemp)
    paymentLoading.value = false
    closeModal()
    fetchSalesOrders()
}

// {{ Add type annotation for salesOrder parameter }}
const openModal = (salesOrder: SalesOrder | null = null) => {
    paymentLoading.value = false
    if (salesOrder) {
        modalTitle.value = 'Sales Order'
        Object.assign(form, salesOrder);
        form.transaction_date = formatDateTimeLocal(new Date(salesOrder.transaction_date));
        form.bank = null;
        form.bank_account = null;
        form.bank = bankOptions.value.find((item) => item.ID === form.bank_id);
        if (form.bank === undefined) {
            form.bank = null;
        } else {
            setTimeout(() => {
                form.bank_account = bankAccountOptions.value.find((item) => item.ID === form.bank_account_id);
            }, 300);
        }
    }
    if (bsModal) { // Check if bsModal is initialized
        bsModal.show()
    }
}

function formatDateTimeLocal(date: any) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}
const closeModal = () => {
    if (bsModal) { // Check if bsModal is initialized
        bsModal.hide()
    }
}
// {{ Define statusSalesOrder function }}
const statusSalesOrder = (salesOrder: SalesOrder) => {
    openModal(salesOrder); // Call openModal with the salesOrder data
}

function formatDateTime(dateString: string, part: string = "-", partTime: string = " "): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    return `${dd}${part}${mm}${part}${yyyy}${partTime}${hh}:${min}`;
}

function formatCurrency(value: number) {
    return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0
    }).format(value);
}

async function copyMapsLink(item: any) {
    const loc = item?.locations || ''
    if (!loc) {
        toast.warning('Location belum ada')
        return
    }
    const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(loc)}`
    try {
        if (navigator?.clipboard?.writeText) {
            await navigator.clipboard.writeText(url)
        } else {
            const ta = document.createElement('textarea')
            ta.value = url
            ta.setAttribute('readonly', '')
            ta.style.position = 'fixed'
            ta.style.left = '-9999px'
            document.body.appendChild(ta)
            ta.focus()
            ta.select()
            document.execCommand('copy')
            document.body.removeChild(ta)
        }
        toast.success('Link Google Maps berhasil dicopy')
    } catch (e) {
        toast.error('Gagal copy link')
    }
}

function formatSeparator(value: number): string {
    return new Intl.NumberFormat('id-ID', {
        style: 'decimal',
        minimumFractionDigits: 0
    }).format(value);
}

// New functions for invoice
function formatCurrencyIDR(value: number) {
    return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        minimumFractionDigits: 0
    }).format(value); // Format as IDR
}

function formatDate(dateString: string) {
  if (!dateString) return '';
    const date = new Date(dateString);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
}

function getServiceUnit(serviceName: string) {
    // Determine unit based on service type
    if (serviceName.toLowerCase().includes('design') || serviceName.toLowerCase().includes('graphic')) {
        return 'project';
    } else if (serviceName.toLowerCase().includes('hour') || serviceName.toLowerCase().includes('consultation')) {
        return 'hours';
    }
    return 'project';
}

function calculateSubtotal() {
    if (!invoiceForm.order_details) return 0;
    return invoiceForm.order_details.reduce((sum: number, item: any) => sum + item.total, 0);
}

function calculateTax() {
    return calculateSubtotal() * 0.08; // 8% tax
}

const isZoomed = ref(false);

const toggleZoom = () => {
    isZoomed.value = !isZoomed.value;
};

// Waybill Modal Functions
const waybillModalRef = ref<HTMLElement | null>(null)
let bsWaybillModal: any | null = null
const printLoading = ref(false)

// Invoice Modal Functions
const invoiceModalRef = ref<HTMLElement | null>(null)
let bsInvoiceModal: any | null = null

const waybillForm = reactive({
    ID: null,
    code: '',
    shipping_name: '',
    waybill_no: '',
    transaction_date: '',
    divisi_team_name: '',
    sales_name: '',
    sales_email: '',
    customer_name: '',
    customer_phone: '',
    customer_address: '',
    customer_city: '',
    customer_province: '',
    order_details: [] as any[],
    courier_name: '',
    shipping_cost: 0,
    fee_amount: 0,
    qty_total: 0,
    order_status: '',
    grand_total: 0
})

const openWaybillModal = (salesOrder: any) => {
    Object.assign(waybillForm, salesOrder)
    if (bsWaybillModal) {
        bsWaybillModal.show()
    }
}

const closeWaybillModal = () => {
    if (bsWaybillModal) {
        bsWaybillModal.hide()
    }
}

// Invoice Modal Functions
const invoiceForm = reactive({
    ID: 0,
    code: '',
    transaction_date: '',
    customer_name: '',
    customer_phone: '',
    customer_address: '',
    customer_city: '',
    customer_province: '',
    divisi_team_name: '',
    sales_name: '',
    order_details: [] as any[],
    shipping_cost: 0,
    fee_amount: 0,
    grand_total: 0,
    bank_name: '',
    bank_account_name: '',
    bank_account_number: ''
})

const openInvoiceModal = (salesOrder: any) => {
    Object.assign(invoiceForm, salesOrder)
    if (bsInvoiceModal) {
        bsInvoiceModal.show()
    }
}

const closeInvoiceModal = () => {
    if (bsInvoiceModal) {
        bsInvoiceModal.hide()
    }
}

const printInvoiceToPNG = async () => {
    printLoading.value = true
    try {
        // Import html2canvas dynamically
        const html2canvas = (await import('html2canvas')).default

        const element = document.getElementById('invoice-content')
        if (!element) {
            throw new Error('Invoice element not found')
        }

        // Create a temporary container for printing
        const printContainer = element.cloneNode(true) as HTMLElement
        printContainer.id = 'invoice-print-temp'

        // Apply print-specific styles to the cloned element for wider PNG output
        printContainer.style.position = 'absolute'
        printContainer.style.left = '-9999px'
        printContainer.style.top = '0'
        printContainer.style.width = '900px' // Wider for better readability
        printContainer.style.minHeight = '1200px' // Proportional height
        printContainer.style.maxWidth = 'none'
        printContainer.style.maxHeight = 'none'
        printContainer.style.overflow = 'visible'
        printContainer.style.transform = 'scale(1)'
        printContainer.style.backgroundColor = '#ffffff'
        printContainer.style.padding = '60px' // Adequate margin
        printContainer.style.boxSizing = 'border-box'
        printContainer.style.display = 'block'
        printContainer.style.margin = '0'
        printContainer.style.fontFamily = 'Arial, sans-serif'

        // Ensure all child elements are visible and properly sized
        const allElements = printContainer.querySelectorAll('*')
        allElements.forEach((el: any) => {
            el.style.overflow = 'visible'
            el.style.maxHeight = 'none'
            el.style.height = 'auto'
            el.style.maxWidth = 'none'
        })

        // Specifically style the company logo for PNG export
        const logoImg = printContainer.querySelector('.company-logo-img') as HTMLImageElement
        if (logoImg) {
            logoImg.style.maxHeight = '60px'
            logoImg.style.maxWidth = '150px'
            logoImg.style.objectFit = 'contain'
            logoImg.style.display = 'block'
            logoImg.style.marginLeft = 'auto'
            logoImg.style.visibility = 'visible'
            logoImg.style.opacity = '1'
            // Ensure the image is loaded
            if (!logoImg.complete) {
                await new Promise((resolve) => {
                    logoImg.onload = resolve
                    logoImg.onerror = resolve
                })
            }
        }

        // Add to document
        document.body.appendChild(printContainer)

        // Wait for rendering and layout calculation
        await new Promise(resolve => setTimeout(resolve, 500))

        console.log('Generating invoice canvas...')

        // Generate canvas with html2canvas for wider PNG output
        const canvas = await html2canvas(printContainer, {
            width: 900, // Wider canvas for better readability
            height: Math.max(1200, printContainer.scrollHeight), // Proportional height
            scale: 2, // Higher scale for better quality
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#ffffff',
            scrollX: 0,
            scrollY: 0,
            logging: true,
            removeContainer: false
        })

        console.log('Canvas generated:', canvas.width, 'x', canvas.height)

        // Remove temporary element
        document.body.removeChild(printContainer)

        // Convert canvas to data URL and download
        const dataURL = canvas.toDataURL('image/png', 1.0)

        // Create download link
        const link = document.createElement('a')
        link.href = dataURL
        link.download = `invoice-${invoiceForm.code}.png`
        link.style.display = 'none'

        // Add to document, click, and remove
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        console.log('Invoice PNG download triggered')
        toast.success('Invoice PNG berhasil didownload!')

    } catch (error) {
        console.error('Error generating invoice PNG:', error)
        toast.error('Gagal membuat PNG: ' + (error as Error).message)
    }
    printLoading.value = false
}

const printInvoiceToPDF = async () => {
    printLoading.value = true
    try {
        // Import html2canvas and jsPDF dynamically
        const html2canvas = (await import('html2canvas')).default
        const { jsPDF } = await import('jspdf')

        const element = document.getElementById('invoice-content')
        if (!element) {
            throw new Error('Invoice element not found')
        }

        // Create a temporary container for printing with A4 dimensions
        const printContainer = element.cloneNode(true) as HTMLElement
        printContainer.id = 'invoice-print-temp-pdf'

        // Apply print-specific styles for A4 (210x297mm)
        printContainer.style.position = 'absolute'
        printContainer.style.left = '-9999px'
        printContainer.style.top = '0'
        printContainer.style.width = '794px' // A4 width at 96 DPI
        printContainer.style.minHeight = '1123px' // A4 height at 96 DPI
        printContainer.style.maxWidth = 'none'
        printContainer.style.maxHeight = 'none'
        printContainer.style.overflow = 'visible'
        printContainer.style.transform = 'scale(1)'
        printContainer.style.backgroundColor = '#ffffff'
        printContainer.style.padding = '40px'
        printContainer.style.boxSizing = 'border-box'
        printContainer.style.display = 'block'
        printContainer.style.margin = '0'
        printContainer.style.fontFamily = 'Arial, sans-serif'

        // Ensure all child elements are visible and properly sized
        const allElements = printContainer.querySelectorAll('*')
        allElements.forEach((el: any) => {
            el.style.overflow = 'visible'
            el.style.maxHeight = 'none'
            el.style.height = 'auto'
            el.style.maxWidth = 'none'
        })

        // Specifically style the company logo for PDF export
        const logoImg = printContainer.querySelector('.company-logo-img') as HTMLImageElement
        if (logoImg) {
            logoImg.style.maxHeight = '80px'
            logoImg.style.maxWidth = '180px'
            logoImg.style.objectFit = 'contain'
            logoImg.style.display = 'block'
            logoImg.style.marginLeft = 'auto'
            logoImg.style.visibility = 'visible'
            logoImg.style.opacity = '1'
            // Ensure the image is loaded
            if (!logoImg.complete) {
                await new Promise((resolve) => {
                    logoImg.onload = resolve
                    logoImg.onerror = resolve
                })
            }
        }

        // Add to document
        document.body.appendChild(printContainer)

        // Wait for rendering and layout calculation
        await new Promise(resolve => setTimeout(resolve, 500))

        console.log('Generating canvas for PDF...')

        // Generate canvas with html2canvas
        const canvas = await html2canvas(printContainer, {
            width: 794,
            height: Math.max(1123, printContainer.scrollHeight),
            scale: 2, // Higher scale for better PDF quality
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#ffffff',
            scrollX: 0,
            scrollY: 0,
            logging: true,
            removeContainer: false
        })

        console.log('Canvas generated for PDF:', canvas.width, 'x', canvas.height)

        // Remove temporary element
        document.body.removeChild(printContainer)

        // Create PDF with A4 dimensions
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4'
        })

        // Convert canvas to image and add to PDF
        const imgData = canvas.toDataURL('image/png', 1.0)

        // Calculate dimensions to fit A4
        const pdfWidth = 210 // A4 width in mm
        const pdfHeight = 297 // A4 height in mm
        const imgWidth = canvas.width
        const imgHeight = canvas.height
        const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight)
        const imgX = (pdfWidth - imgWidth * ratio) / 2
        const imgY = 0

        // Add image to PDF
        pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio)

        // Save the PDF
        pdf.save(`invoice-${invoiceForm.code}.pdf`)

        console.log('PDF download triggered')
        toast.success('Invoice PDF berhasil didownload!')

    } catch (error) {
        console.error('Error generating PDF:', error)
        toast.error('Gagal membuat PDF: ' + (error as Error).message)
    }
    printLoading.value = false
}

const printWaybillToPNG = async () => {
    printLoading.value = true
    try {
        // Import html2canvas dynamically
        const html2canvas = (await import('html2canvas')).default

        const element = document.getElementById('waybill-content')
        if (!element) {
            throw new Error('Waybill element not found')
        }

        // Create a temporary container for printing
        const printContainer = element.cloneNode(true) as HTMLElement
        printContainer.id = 'waybill-print-temp'

        // Remove modal-specific classes and styles
        printContainer.classList.remove('waybill-modal-view')

        // Apply print-specific styles to the cloned element
        printContainer.style.position = 'absolute'
        printContainer.style.left = '-9999px'
        printContainer.style.top = '0'
        printContainer.style.width = '576px' // Standard landscape width
        printContainer.style.height = '384px' // Standard landscape height
        printContainer.style.maxWidth = 'none'
        printContainer.style.maxHeight = 'none'
        printContainer.style.fontSize = '10px'
        printContainer.style.overflow = 'visible'
        printContainer.style.transform = 'scale(1)'
        printContainer.style.backgroundColor = '#ffffff'
        printContainer.style.padding = '12px'
        printContainer.style.boxSizing = 'border-box'
        printContainer.style.display = 'block'
        printContainer.style.margin = '0'

        // Ensure all child elements are visible and properly sized
        const allElements = printContainer.querySelectorAll('*')
        allElements.forEach((el: any) => {
            el.style.overflow = 'visible'
            el.style.maxHeight = 'none'
            el.style.height = 'auto'
            el.style.maxWidth = 'none'
        })

        // Add to document
        document.body.appendChild(printContainer)

        // Wait for rendering and layout calculation
        await new Promise(resolve => setTimeout(resolve, 500))

        console.log('Generating canvas...')

        // Generate canvas with html2canvas
        const canvas = await html2canvas(printContainer, {
            width: 576,
            height: 454,
            scale: 2, // Higher scale for better quality
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#ffffff',
            scrollX: 0,
            scrollY: 0,
            logging: true, // Enable logging for debugging
            removeContainer: false
        })

        console.log('Canvas generated:', canvas.width, 'x', canvas.height)

        // Remove temporary element
        document.body.removeChild(printContainer)

        // Convert canvas to data URL and download
        const dataURL = canvas.toDataURL('image/png', 1.0)

        // Create download link
        const link = document.createElement('a')
        link.href = dataURL
        link.download = `waybill-landscape-${waybillForm.code}.png`
        link.style.display = 'none'

        // Add to document, click, and remove
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        console.log('Download triggered')
        toast.success('Waybill landscape berhasil didownload!')

    } catch (error) {
        console.error('Error generating PNG:', error)
        toast.error('Gagal membuat PNG: ' + (error as Error).message)
    }
    printLoading.value = false
}

const printWaybillToPDF = async () => {
    printLoading.value = true
    try {
        // Import html2canvas and jsPDF dynamically
        const html2canvas = (await import('html2canvas')).default
        const { jsPDF } = await import('jspdf')

        const element = document.getElementById('waybill-content')
        if (!element) {
            throw new Error('Waybill element not found')
        }

        // Create a temporary container for printing with 4x6 inch dimensions
        const printContainer = element.cloneNode(true) as HTMLElement
        printContainer.id = 'waybill-print-temp-pdf'

        // Remove modal-specific classes and styles
        printContainer.classList.remove('waybill-modal-view')

        // Apply print-specific styles for 4x6 inch (288x432 points at 72 DPI)
        // Convert to pixels: 4 inches = 288px, 6 inches = 432px at 72 DPI
        printContainer.style.position = 'absolute'
        printContainer.style.left = '-9999px'
        printContainer.style.top = '0'
        printContainer.style.width = '288px' // 4 inches at 72 DPI
        printContainer.style.height = '432px' // 6 inches at 72 DPI
        printContainer.style.maxWidth = 'none'
        printContainer.style.maxHeight = 'none'
        printContainer.style.fontSize = '8px' // Smaller font for 4x6 format
        printContainer.style.overflow = 'visible'
        printContainer.style.transform = 'scale(1)'
        printContainer.style.backgroundColor = '#ffffff'
        printContainer.style.padding = '8px'
        printContainer.style.boxSizing = 'border-box'
        printContainer.style.display = 'block'
        printContainer.style.margin = '0'

        // Ensure all child elements are visible and properly sized
        const allElements = printContainer.querySelectorAll('*')
        allElements.forEach((el: any) => {
            el.style.overflow = 'visible'
            el.style.maxHeight = 'none'
            el.style.height = 'auto'
            el.style.maxWidth = 'none'
        })

        // Add to document
        document.body.appendChild(printContainer)

        // Wait for rendering and layout calculation
        await new Promise(resolve => setTimeout(resolve, 500))

        console.log('Generating canvas for PDF...')

        // Generate canvas with html2canvas
        const canvas = await html2canvas(printContainer, {
            width: 288,
            height: 432,
            scale: 3, // Higher scale for better PDF quality
            useCORS: true,
            allowTaint: true,
            backgroundColor: '#ffffff',
            scrollX: 0,
            scrollY: 0,
            logging: true,
            removeContainer: false
        })

        console.log('Canvas generated for PDF:', canvas.width, 'x', canvas.height)

        // Remove temporary element
        document.body.removeChild(printContainer)

        // Create PDF with 4x6 inch dimensions
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'in',
            format: [4, 6] // 4x6 inches
        })

        // Convert canvas to image and add to PDF
        const imgData = canvas.toDataURL('image/png', 1.0)

        // Add image to PDF with full page coverage
        pdf.addImage(imgData, 'PNG', 0, 0, 4, 6)

        // Save the PDF
        pdf.save(`waybill-4x6-${waybillForm.code}.pdf`)

        console.log('PDF download triggered')
        toast.success('Waybill PDF 4x6 berhasil didownload!')

    } catch (error) {
        console.error('Error generating PDF:', error)
        toast.error('Gagal membuat PDF: ' + (error as Error).message)
    }
    printLoading.value = false
}

// Related Orders Functions
const checkRelated = async (order: any) => {
    try {
        selectedOrder.value = order
        relatedOrdersLoading.value = true
        relatedOrders.value = []

        // Show modal
        const modal = new Modal(relatedOrdersModalRef.value)
        modal.show()

        // Call API to get related orders
        const response = await sales.getRequest(`/order/related`, { ID: order.ID })


        if (response && response.data) {
            relatedOrders.value = response.data
        } else {
            relatedOrders.value = []
        }

    } catch (error) {
        console.error('Error fetching related orders:', error)
        toast.error('Failed to fetch related orders')
        relatedOrders.value = []
    } finally {
        relatedOrdersLoading.value = false
    }
}

const closeRelatedOrdersModal = () => {
    const modal = Modal.getInstance(relatedOrdersModalRef.value)
    if (modal) {
        modal.hide()
    }
    relatedOrders.value = []
    selectedOrder.value = {}
}

const viewOrderDetails = (order: any) => {
    // Close related orders modal first
    closeRelatedOrdersModal()

    // Open the main order modal with the selected order
    openModal(order)
}

const getStatusBadgeClass = (status: string) => {
    const statusClasses = {
        'PENDING': 'badge bg-warning text-dark',
        'CONFIRMED': 'badge bg-info text-white',
        'PROCESSING': 'badge bg-primary text-white',
        'SHIPPED': 'badge bg-success text-white',
        'DELIVERED': 'badge bg-success text-white',
        'CANCELLED': 'badge bg-danger text-white',
        'REJECTED': 'badge bg-danger text-white'
    }
    return statusClasses[status] || 'badge bg-secondary text-white'
}

// Initial fetch is now called in onMounted
</script>

<style scoped>
.zoomed {
    transform: scale(100);
    transition: transform 0.3s ease;
}

/* Waybill Styles */
.waybill-container {
    background: white;
    padding: 12px;
    font-family: Arial, sans-serif;
    color: #000;
    width: 576px;
    height: 384px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* Modal view specific styles */
.waybill-modal-view {
    width: 100% !important;
    height: auto !important;
    min-height: 384px;
    max-width: 800px;
    margin: 0 auto;
    overflow: visible !important;
}

.waybill-modal-view .waybill-header h3,
.waybill-modal-view .waybill-header h4 {
    font-size: 16px;
}

.waybill-modal-view .sender-info h5,
.waybill-modal-view .receiver-info h5,
.waybill-modal-view .package-info h5 {
    font-size: 14px;
}

.waybill-modal-view .sender-info p,
.waybill-modal-view .receiver-info p {
    font-size: 12px;
}

.waybill-modal-view .package-info table {
    font-size: 12px;
}

.waybill-modal-view .package-info th,
.waybill-modal-view .package-info td {
    font-size: 12px;
    padding: 8px;
}

.waybill-modal-view .shipping-info p,
.waybill-modal-view .cost-summary p {
    font-size: 12px;
}

.waybill-modal-view .signature-box p {
    font-size: 11px;
}

.waybill-modal-view .waybill-footer p {
    font-size: 11px;
}

.waybill-header {
    border-bottom: 2px solid #000;
    padding-bottom: 8px;
    margin-bottom: 12px;
}

.waybill-header h3 {
    margin: 0;
    font-weight: bold;
    font-size: 14px;
}

.waybill-header h4 {
    margin: 0;
    font-weight: bold;
    font-size: 12px;
}

.sender-info,
.receiver-info {
    border: 1px solid #ccc;
    padding: 8px;
    border-radius: 3px;
    background-color: #f9f9f9;
    margin-bottom: 8px;
}

.sender-info h5,
.receiver-info h5 {
    margin-top: 0;
    margin-bottom: 5px;
    color: #333;
    font-weight: bold;
    font-size: 10px;
}

.sender-info p,
.receiver-info p {
    margin: 2px 0;
    font-size: 9px;
    line-height: 1.2;
}

.package-info h5 {
    margin-bottom: 8px;
    color: #333;
    font-weight: bold;
    font-size: 10px;
}

.package-info table {
    margin-bottom: 8px;
    font-size: 8px;
}

.package-info th,
.package-info td {
    padding: 3px;
    font-size: 8px;
}

.package-info th {
    background-color: #f8f9fa;
    font-weight: bold;
}

.shipping-info {
    border: 1px solid #ddd;
    padding: 8px;
    border-radius: 3px;
    background-color: #f8f9fa;
    margin-bottom: 8px;
}

.shipping-info p {
    margin: 2px 0;
    font-size: 9px;
}

.signature-box {
    text-align: center;
    border: 1px solid #ccc;
    padding: 0px;
    border-radius: 3px;
    background-color: #f9f9f9;
}

.signature-line {
    border-bottom: 1px solid #000;
    margin: 20px 10px 5px 10px;
    height: 1px;
}

.signature-box p {
    font-size: 8px;
    margin: 2px 0;
}

.waybill-footer {
    border-top: 1px solid #ddd;
    padding-top: 8px;
}

.waybill-footer p {
    font-size: 8px;
    margin: 2px 0;
}

/* Landscape specific optimizations */
.waybill-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.cost-summary p {
    margin: 1px 0;
    font-size: 9px;
}

.d-flex.justify-content-between {
    align-items: flex-start;
}

.signature-box {
    min-height: 60px;
}

/* Print specific styles */
@media print {
    .waybill-container {
        box-shadow: none;
        border: none;
    }
}

.waybill-modal-view .package-info th,
.waybill-modal-view .package-info td {
    font-size: 12px;
    padding: 0px;
}

/* Invoice Styles - Following Design Studio Template */
.invoice-container {
    background: white;
    padding: 0;
    font-family: 'Arial', sans-serif;
    color: #333;
    line-height: 1.6;
    max-width: 800px;
    margin: 0 auto;
}

/* Header with teal background */
.invoice-header-bg {
    background: linear-gradient(135deg, #4a9b8e 0%, #2c5f5a 100%);
    color: white;
    padding: 30px;
    margin: -20px -20px 0 -20px;
}

.invoice-header-content {
    max-width: 100%;
}

.invoice-main-title {
    font-size: 3rem;
    font-weight: bold;
    margin: 0;
    color: white;
}

.company-logo {
    display: flex;
    align-items: center;
    gap: 15px;
}

.logo-icon {
    background: #f39c12;
    color: white;
    width: 60px;
    height: 60px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: bold;
    text-transform: lowercase;
}

.logo-text {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
}

.design-text {
    font-size: 24px;
    font-weight: bold;
    color: white;
}

.studio-text {
    font-size: 24px;
    font-weight: normal;
    color: white;
}

/* Invoice details section */
.invoice-details-section {
    padding: 30px;
    border-bottom: 1px solid #eee;
}

.invoice-number,
.invoice-date {
    margin-bottom: 8px;
    font-size: 14px;
}

.company-details p {
    margin-bottom: 5px;
    font-size: 14px;
}

/* Bill To Section */
.bill-to-section {
    padding: 30px;
    padding-top: 5px;
    padding-bottom: 5px;
    border-bottom: 1px solid #eee;
}

.section-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
}

.client-info p,
.payment-info p {
    margin-bottom: 8px;
    font-size: 14px;
}

.client-name,
.company-name {
    font-weight: 600;
}

/* Service Details Section */
.service-details-section {
    padding: 30px;
    border-bottom: 1px solid #eee;
}

.service-table-container {
    margin-top: 20px;
}

.service-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
}

.service-table .table-header {
    background-color: #f39c12;
    color: white;
}

.service-table th {
    padding: 15px 10px;
    text-align: left;
    font-weight: bold;
    border: none;
}

.service-table .no-col {
    width: 8%;
    text-align: center;
}

.service-table .description-col {
    width: 40%;
}

.service-table .quantity-col {
    width: 17%;
    text-align: center;
}

.service-table .rate-col {
    width: 17%;
    text-align: right;
}

.service-table .total-col {
    width: 18%;
    text-align: right;
}

.service-table .table-row {
    background-color: #f8f9fa;
}

.service-table .table-row:nth-child(even) {
    background-color: white;
}

.service-table td {
    padding: 12px 10px;
    border-bottom: 1px solid #dee2e6;
    vertical-align: middle;
}

/* Terms and Total Section */
.terms-section {
    padding: 20px 0;
}

.terms-list {
    list-style-type: disc;
    padding-left: 20px;
    margin: 0;
}

.terms-list li {
    margin-bottom: 8px;
    font-size: 14px;
}

.total-calculation {
    padding: 20px;
    background-color: #f8f9fa;
    border-radius: 8px;
    margin-top: 20px;
}

.subtotal-row,
.tax-row,
.total-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    padding: 8px 0;
}

.total-row {
    border-top: 2px solid #333;
    margin-top: 15px;
    padding-top: 15px;
    font-size: 18px;
}

/* Payment Information Section */
.payment-info-section {
    background-color: #2c5f5a;
    color: white;
    padding: 30px;
    margin: 0 -20px;
}

.section-title-white {
    font-size: 20px;
    font-weight: bold;
    color: white;
    margin-bottom: 20px;
}

.payment-details p {
    margin-bottom: 8px;
    font-size: 14px;
    color: white;
}

.signature-section {
    text-align: right;
}

.date-text {
    margin-bottom: 30px;
    font-size: 14px;
    color: white;
}

.signature-line {
    border-bottom: 2px solid white;
    width: 200px;
    margin: 20px 0 10px auto;
}

.signature-name {
    font-size: 14px;
    color: white;
    margin: 0;
}

/* Questions Section */
.questions-section {
    padding: 30px;
    background-color: #f8f9fa;
    margin: 0 -20px -20px -20px;
}

.contact-info p {
    margin-bottom: 5px;
    font-size: 14px;
}

/* Print specific styles for invoice */
@media print {
    .invoice-container {
        box-shadow: none;
        border: none;
        padding: 0;
    }

    .modal-header,
    .modal-footer {
        display: none !important;
    }

    .modal-body {
        padding: 0 !important;
    }
}
</style>
